export const salesContractClauses = [
  { field: 'shippingTerms', label: '1. Shipping Terms / 装运条款' },
  { field: 'paymentClause', label: '2. Payment Terms / 付款条款' },
  { field: 'insuranceClause', label: '3. Insurance / 保险' },
  { field: 'documentsRequired', label: '4. Documents Required / 单据要求' },
  { field: 'inspectionClause', label: '5. Inspection / 检验' },
  { field: 'forceMajeureClause', label: '6. Force Majeure / 不可抗力' },
  { field: 'claimsClause', label: '7. Claims / 索赔' },
  { field: 'arbitrationClause', label: '8. Arbitration / 仲裁条款' },
] as const;

export type SalesContractClauseField = typeof salesContractClauses[number]['field'];
export type SalesContractTerms = Partial<Record<SalesContractClauseField, string | null>>;
